export default "__VITE_ASSET__B96NXmaa__"